@use "../../styles/breakpoint" as *;

.root {
    position: relative;
    overflow: hidden;
}

.linkImage {
    display: inline-block;
    height: auto;
    max-width: 100%;
}
